const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
});

export const formatToPrecession = (value: number, precision: number) => {
  return Number(value.toFixed(precision));
};
export default formatter;
